import { metrics } from '@atlassian/browser-metrics';
import { TTI_RAF_MARK, TTI_RAF_KEY } from '@atlassian/jira-providers-spa-apdex-analytics';

export const PAGE_LOAD_MARK_CONSTRUCTOR_START = 'CONSTRUCTOR_START';
export const PAGE_LOAD_MARK_CONSTRUCTOR_END = 'CONSTRUCTOR_END';
export const PAGE_LOAD_MARK_REDUX_START = 'REDUX_START';
export const PAGE_LOAD_MARK_REDUX_END = 'REDUX_END';
export const PAGE_LOAD_MARK_TRANSFORM_CRITICAL_START = 'TRANSFORM_CRITICAL_START';
export const PAGE_LOAD_MARK_TRANSFORM_CRITICAL_END = 'TRANSFORM_CRITICAL_END';
export const PAGE_LOAD_MARK_RENDER_START = 'RENDER_START';
export const PAGE_LOAD_MARK_RENDER_END = 'RENDER_END';

export const CRITICAL_RELAY_RESOURCE_GET_DATA_START =
	'relay_resource_get_data:NEXTGEN_BACKLOG_RELAY:start';
export const CRITICAL_RELAY_RESOURCE_GET_DATA_END =
	'relay_resource_get_data:NEXTGEN_BACKLOG_RELAY:end';

export const PAGE_LOAD_MARK_TRANSFORM_CRITICAL_REST_START = 'TRANSFORM_CRITICAL_REST_START';
export const PAGE_LOAD_MARK_TRANSFORM_CRITICAL_REST_END = 'TRANSFORM_CRITICAL_REST_END';

export const USE_RESOURCE_START = 'USE_RESOURCE_START';
export const USE_RESOURCE_READY = 'USE_RESOURCE_READY';
export const RENDER_START = 'RENDER_START_FRAME';
export const RENDER_END = 'RENDER_END_FRAME';
export const JSW_CRITICAL_RESOURCE_START = 'JSW_CRITICAL_RESOURCE_START';
export const JSW_CRITICAL_RESOURCE_END = 'JSW_CRITICAL_RESOURCE_END';
export const EARLY_FETCH_START = 'EARLY_FETCH_START';
export const EARLY_FETCH_END = 'EARLY_FETCH_END';

const NEXT_GEN_BACKLOG = 'next-gen-backlog';
const UIF_BACKLOG_NEW_UI = 'classic-backlog';

type BACKLOG_TYPE = typeof NEXT_GEN_BACKLOG | typeof UIF_BACKLOG_NEW_UI;

const backlogPageLoad = (key: BACKLOG_TYPE) =>
	metrics.pageLoad({
		key,
		featureFlags: [],
		ssr: {
			doneAsFmp: true,
		},
		slo: {
			fmp: {
				initial: { threshold: 1000 },
				transition: { threshold: 1000 },
			},
			tti: {
				initial: { threshold: 14000 },
				transition: { threshold: 14000 },
			},
		},
		timings: [
			{
				key: 'product/page-constructor',
				startMark: PAGE_LOAD_MARK_CONSTRUCTOR_START,
				endMark: PAGE_LOAD_MARK_CONSTRUCTOR_END,
			},
			{
				key: 'product/page-constructor/redux-setup',
				startMark: PAGE_LOAD_MARK_REDUX_START,
				endMark: PAGE_LOAD_MARK_REDUX_END,
			},
			{
				key: 'product/page-constructor/redux-setup/transform-critical-data',
				startMark: PAGE_LOAD_MARK_TRANSFORM_CRITICAL_START,
				endMark: PAGE_LOAD_MARK_TRANSFORM_CRITICAL_END,
			},
			{
				key: 'product/page-constructor/redux-setup/transform-critical-rest-data',
				startMark: PAGE_LOAD_MARK_TRANSFORM_CRITICAL_REST_START,
				endMark: PAGE_LOAD_MARK_TRANSFORM_CRITICAL_REST_END,
			},
			{
				key: 'product/render',
				startMark: PAGE_LOAD_MARK_RENDER_START,
				endMark: PAGE_LOAD_MARK_RENDER_END,
			},
			{
				key: 'fixed-render',
				startMark: RENDER_START,
				endMark: RENDER_END,
			},
			{
				key: 'use-resource-call',
				startMark: USE_RESOURCE_START,
				endMark: USE_RESOURCE_READY,
			},
			{
				key: 'critical-resource-get-data',
				startMark: CRITICAL_RELAY_RESOURCE_GET_DATA_START,
				endMark: CRITICAL_RELAY_RESOURCE_GET_DATA_END,
			},
			{
				key: 'critical-resource',
				startMark: JSW_CRITICAL_RESOURCE_START,
				endMark: JSW_CRITICAL_RESOURCE_END,
			},
			{
				key: 'early-fetch',
				startMark: EARLY_FETCH_START,
				endMark: EARLY_FETCH_END,
			},
			{ key: TTI_RAF_KEY, endMark: TTI_RAF_MARK },
		],
	});

export const nextGenBacklogPageLoad = backlogPageLoad(NEXT_GEN_BACKLOG);
export const uifBacklogNewUiPageLoad = backlogPageLoad(UIF_BACKLOG_NEW_UI);

export const issueViewOpenInteraction = metrics.interaction({
	key: 'backlog.issue-view-open',
	// @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.response]' is missing in type '{ result: string; }' but required in type 'InteractionHistogramConfig'.
	histogram: {
		result: '1000_2000_3000_4000_5000_6000',
	},
	timings: [{ key: 'feedbackPreMount', endMark: 'feedbackPreMountEnd' }],
});

export const issueRankInteraction = metrics.interaction({
	key: 'backlog.issue-rank',
	histogram: {
		result: '1000_2000_3000_4000_5000_6000',
		response: '100_200_500_1000_1500',
	},
});

export const filterInteraction = metrics.interaction({
	key: 'backlog.filter',
	// @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.response]' is missing in type '{ result: string; }' but required in type 'InteractionHistogramConfig'.
	histogram: {
		result: '100_200_500_1000_1200_1500',
	},
});

export const cardHoverStateInteraction = metrics.interaction({
	key: 'backlogCardRenderHoverState',
	histogram: {
		result: '100_200_300_500_700_1000_1250_1500_1750_2000_2500_3000',
		response: '',
	},
	timings: [{ key: 'backlogCardHover', endMark: 'backlogCardHoverRendered' }],
});

export const cardMouseLeaveTiming = metrics.interaction({
	key: 'backlogCardMouseLeaveTiming',
	histogram: {
		result: '100_200_300_500_700_1000_1250_1500_1750_2000_2500_3000',
		response: '',
	},
	timings: [{ key: 'backlogCardMouseLeaveTiming', endMark: 'backlogCardMouseLeaveTimingEnd' }],
});

export const cardDragDropTargetTiming = metrics.interaction({
	key: 'backlogCardDragDropTargetTiming',
	histogram: {
		result: '100_200_300_500_700_1000_1250_1500_1750_2000_2500_3000',
		response: '',
	},
	timings: [
		{ key: 'backlogCardDragDropTargetTiming', endMark: 'backlogCardDragDropTargetRendered' },
	],
});

export const issueCreateInteraction = metrics.concurrent.interaction({
	key: 'backlog.issue-create',
	// @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.response]' is missing in type '{ result: string; }' but required in type 'InteractionHistogramConfig'.
	histogram: {
		result: '1000_2000_3000_4000_5000',
	},
});

export const issueDeleteInteraction = metrics.concurrent.interaction({
	key: 'backlog.issue-delete',
});

export const flagToggleInteraction = metrics.concurrent.interaction({
	key: 'backlog.flag-toggle',
	histogram: {
		result: '1000_2000_3000_4000_5000_6000',
		response: '50_100_150_200_300_500',
	},
});

export const assignToMeInteraction = metrics.concurrent.interaction({
	key: 'backlog.assign-to-me',
	// @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.result]' is missing in type '{ response: string; }' but required in type 'InteractionHistogramConfig'.
	histogram: {
		response: '50_100_150_200_300_400_500',
	},
});

export const cardListToggleInteraction = metrics.interaction({
	key: 'backlog.card-list-toggle',
});

export const createSprintInteraction = metrics.concurrent.interaction({
	key: 'backlog.sprint-create',
});

export const deleteSprintInteraction = metrics.concurrent.interaction({
	key: 'backlog.sprint-delete',
	// @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.response]' is missing in type '{ result: string; }' but required in type 'InteractionHistogramConfig'.
	histogram: {
		result: '500_1000_1500_2000_2500_3000_3500_4000',
	},
});

export const moveSprintInteraction = metrics.interaction({
	key: 'backlog.sprint-move',
	// @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.response]' is missing in type '{ result: string; }' but required in type 'InteractionHistogramConfig'.
	histogram: {
		result: '500_1000_1500_2000_2500_3000',
	},
});

export const startSprintModalLoad = metrics.interaction({
	key: 'start-sprint-modal-load',
});

export const completeSprintModalLoad = metrics.interaction({
	key: 'complete-sprint-modal-load',
});

export const customFilterInteraction = metrics.interaction({
	key: 'backlog.custom-filter',
	// @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.response]' is missing in type '{ result: string; }' but required in type 'InteractionHistogramConfig'.
	histogram: {
		result: '500_1000_1500_2000_2500_3000_3500_4000',
	},
});

export const clearCustomFilterInteraction = metrics.interaction({
	key: 'backlog.clear-custom-filter',
});

export const versionsPanelLoad = metrics.interaction({
	key: 'backlog.versions-panel-load',
});

export const inlineEditStatusInteraction = metrics.interaction({
	key: 'backlog.inline-issue-field-status',
});

export const inlineEditAssigneeInteraction = metrics.interaction({
	key: 'backlog.inline-issue-field-assignee',
});

export const inlineEditStoryPointInteraction = metrics.interaction({
	key: 'backlog.inline-issue-field-story-point',
});

export const inlineEditOriginalEstimateInteraction = metrics.interaction({
	key: 'backlog.inline-issue-field-original-estimate',
});
